export default __webpack_public_path__ + "static/media/mockup.14d9ed67.png";